import { DOWNLOAD_ALERTS, FETCH_ALERTS } from 'actions/alerts';
import fileDownload from 'js-file-download';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  alerts: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
  allowedAlertTypes:[]
};
const alertsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ALERTS.REQUEST:
      {
        return { ...state, isLoading: true };
      }

    case DOWNLOAD_ALERTS.REQUEST:
      {
        return { ...state, isLoading: true };
      }

    case FETCH_ALERTS.SUCCESS:
      {
        return {
          ...state,
          isLoading: false,
          alerts: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
          allowedAlertTypes: payload.allowedAlertTypes || [],
        };
      }

    case DOWNLOAD_ALERTS.SUCCESS:
      {
        fileDownload(payload, `Alerts Report.xlsx`);
        toast.success("Report Downloaded")
        return {
          ...state,
          isLoading: false,
          download:payload
        }
      }

    case FETCH_ALERTS.FAIL:
    case DOWNLOAD_ALERTS.FAIL:
      {
        return {
          ...state,
          isLoading: false,
        };
      }
    default:
      return { ...state };
  }
};
export default alertsReducer;
